@if (schemaTranslations) {
  <form [formGroup]="form"
        appJumptoError
        #appJumptoError="appJumptoError"
        [class]="'webform-source-' + source"
        [class.submitted]="isFormSubmitted"
        (submit)="onSubmit($event)"
  >
    <!-- MSISDN AS MAIN IDENTIFIER -->
    @if (settings && !settings['schema'].identifiers) {
      <app-msisdn-input
          class="field-msisdn"
          [readonly]="true"
          [passedFormControl]="$any(form.controls['msisdn'])"
          [showErrors]="true"
          [icon]="false"/>
    }
    <!-- END MSISDN AS MAIN IDENTIFIER -->
    <app-properties-form [formControl]="$any(form.get('properties'))"
                         [consents]="form.value.consents"
                         [properties]="properties"
                         [isFormSubmitted]="isFormSubmitted"
                         [identifiers]="$any(settings.schema['identifiers'])"
                         [isNewProfile]="isNewProfile()"
                         [formErrors]="formErrors"/>
    <!-- EUROSKO-LIKE PARSED TOS -->
    @if (advancedTOS) {
      <div
          class="form-group"
          (tosShow)="privacyPolicy.click()"
          [formControl]="$any(form.get('toc'))"
          [innerHtml]="advancedTOS" appAdvancedTos></div>
    } @else {
      @if (!isConsentsAvailable) {
        <div class="form-group"
             [class.has-error]="isFormSubmitted && (form.errors ? form.errors['toc'] : undefined)"
        >
          <label class="control-label control-label-toc" for="member_form_toc">
            {{ 'generic.terms_of_service' | translate }}
            <span class="required">*</span>
          </label>
          <div class="checkbox">
            <label class="terms-of-service">
              <input type="checkbox" class="required" formControlName="toc" id="member_form_toc">
              <span class="checkbox-material"><span class="check"></span></span>
              {{
                ('generic.tos_notice_angular_html' | translate:{
                  customer_name: $safeNavigationMigration(settings?.name)
                })
              }}
            </label> <a class="privacy-policy-link" target="_blank"
                        [href]="privacyPolicyHref">{{ 'generic.tos_notice_link' | translate }}</a>
          </div>
          <app-input-errors [errorsForField]="(form.errors ? form.errors['toc'] : undefined)"
                            [translationKey]="'errors.members'"/>
        </div>
      } @else {
        @if (consentsTranslations) {
          @if (settings.schema.identifiers && settings.schema.consents) {
            <app-consents
                [isRegistrationScreen]="isNewProfile()"
                formControlName="consents"
                class="field-consents"
                [consentsTranslations]="consentsTranslations"/>
          }
          <app-privacy-policy
              formControlName="tos"
              [editMode]="!isNewProfile()"
              [formErrors]="form.errors && form.errors['tos'] ? form.errors['tos'] : null"
              [customPrivacyPolicy]="consentsTranslations | getConsentsTranslation:'general_privacy_policy'"/>
        }
      }
    }
    <!-- END EUROSKO-LIKE PARSED TOS -->
    <a #privacyPolicy class="hidden" target="_blank"
       [href]="privacyPolicyHref">{{ 'generic.tos_notice_link' | translate }}</a>

    <button class="btn btn-lg btn-raised btn-primary btn-block">
      @if (isNewProfile()) {
        <span>{{ 'profiles.new.submit_button' | translate }}</span>
      }
      @if (!isNewProfile()) {
        <span>{{ 'profiles.edit.submit_button' | translate }}</span>
      }
    </button>
  </form>
}
